<template>
    <div>
        <rednax-datatable ref="todotable" :url="'/vue/sales/crm/todo'" :columns="todo_columns" :filter="todo_filter" @updateFilter="todo_filter=$event" :per-page="2000" @rowclick="rowClick" history>
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="todo_filter.search" class="form-control">
                </div>
                <div class="col-lg-3">
                    <vue-select
                        v-model="todo_filter.date"
                        :options="select_todo_dates"
                        placeholder="Välj..."
                        :reduce="opt => opt.id"
                        label="text"
                        :clearable="false"
                    ></vue-select>
                </div>
                <div class="col-lg-3">
                    <sales-crm-users-filter
                        v-model="todo_filter.user_id"
                        placeholder="-- Alla säljare --"
                        :reduce="opt => opt.id"
                    ></sales-crm-users-filter>
                </div>
                <div class="col-lg-3 text-right">
                    <button type="button" class="btn btn-primary btn-labeled btn-labeled-left" @click="openTodoModal(0)"><b><i class="icon-plus3"></i></b>Skapa ny</button>
                </div>
            </div>
        </rednax-datatable>

        <div id="modal_todo" class="modal fade" data-backdrop="static">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="todo">
                    <div class="modal-header">
                        <h5 v-if="todo.id>0" class="modal-title">{{ todo.subject }}</h5>
                        <h5 v-else class="modal-title">Ny att göra</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <todo-form v-model="todo" :strings="strings" :companies="companies" :users="users" ref="todoform"></todo-form>
                    </div>
                    <div class="modal-footer">
                        <div class="mr-auto">
                            <limitless-button ref="btndeletetodo" type="button" btn-class="btn-danger" icon="icon-cross2" @click="deleteTodo" :busy="todo_busy">RADERA ATT GÖRA</limitless-button>
                        </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                        <limitless-button ref="btnsavetodo" type="button" @click="saveTodo" :busy="todo_busy" icon="icon-floppy-disk">SPARA</limitless-button>
                    </div>
                    <div class="modal-body border-top" v-if="history_company">
                        <history-form v-if="show_history_form_id === 0" :users="users" :strings="strings" :company="history_company" :history-id="0"  @saved="historySaved(-1, $event)"></history-form>
                        <button v-else class="btn btn-light btn-block" @click="showHistoryForm(0)"><i class="icon-plus3 mr-2"></i> Lägg till ny historik</button>

                        <div v-for="(h_item, h_index) in history_company.history" :key="'h-' + h_index" class="mt-3">
                            <history-form v-if="show_history_form_id === h_item.id" :users="users" :strings="strings" :company="history_company" :history-id="h_item.id" @saved="historySaved(h_index, $event)"></history-form>
                            <div v-else class="card mt-3">
                                <div class="card-header py-2 border-bottom header-elements-inline" style="background-color: #ecf6fe;">
                                    <h5 class="font-weight-semibold mb-0">
                                        <span v-if="h_item.type">{{ h_item.type.string }}: </span>{{ h_item.subject }}
                                    </h5>
                                    <div class="header-elements">
                                        <div class="font-weight-semibold text-right no-wrap">{{ h_item.date_time.substr(0, 16) }}</div>
                                    </div>
                                </div>
                                <div class="card-header bg-white d-flex flex-row py-2">
                                    <div class="flex-grow-1">
                                        <div v-if="h_item.contact">
                                            <span class="font-weight-semibold no-wrap">{{ h_item.contact.name }}</span> <span v-if="h_item.contact.work_title">({{ h_item.contact.work_title }})</span>
                                            <div v-if="h_item.contact.email">
                                                <a :href="'mailto:' + h_item.contact.email" >{{ h_item.contact.email }}</a>
                                            </div>
                                            <div v-if="h_item.contact.phone || h_item.contact.mobile_phone">
                                                <a v-if="h_item.contact.phone" :href="'tel:' + h_item.contact.phone" >{{ h_item.contact.phone }}</a>
                                                <span v-if="h_item.contact.phone && h_item.contact.mobile_phone"> / </span>
                                                <a v-if="h_item.contact.mobile_phone" :href="'tel:' + h_item.contact.mobile_phone" >{{ h_item.contact.mobile_phone }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-right">
                                            <div v-if="h_item.seller" class="text-muted no-wrap">{{ h_item.seller.name }}</div>
                                            <a href="" @click.prevent="showHistoryForm(h_item.id)">Redigera</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" v-html="h_item.html">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Att göra</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <i style="color:red;">Kunde ej ladda data</i>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                    </div>
                </div>
            </div>
        </div> <!-- /modal -->
    </div>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import { mapState } from 'pinia';
import HistoryForm from '@app/pages/sales_crm/partials/HistoryForm';
import TodoForm from '@app/pages/sales_crm/partials/TodoForm';
import { useAuthStore } from '@services/pinia/AuthStore';
import VueSelect from '@components/Wrappers/VueSelect.vue';
import SalesCrmUsersFilter from '@components/Filters/SalesCrmUsersFilter.vue';

export default {
    name: 'SalesCrmTodos',
    components: {
        SalesCrmUsersFilter,
        VueSelect,
        TodoForm,
        RednaxDatatable,
        LimitlessButton,
        HistoryForm,
    },
    props: {
        users: {
            type: Array,
            default() {
                return [];
            },
        },
        companies: {
            type: Object,
            default() {
                return {};
            },
        },
        strings: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
    },
    data: () => ({
        todo_busy: false,
        todo: null,
        todo_filter: {
            search: '',
            date: 'today',
            user_id: '',
        },
        todo_columns: [
            {
                header: 'Prioritet',
                data: 'priority',
                sortable: true,
                render(row) {
                    if (row.priority === 1) {
                        return '<span class="badge badge-danger">Hög</span>';
                    } if (row.priority === 2) {
                        return '<span class="badge bg-purple-400">Medel</span>';
                    }
                    return '<span class="badge badge-primary">Låg</span>';
                },
            },
            {
                header: 'Ämne',
                data: 'subject',
                sortable: true,
            },
            {
                header: 'Företag',
                data: 'company_name',
                sortable: true,
            },
            {
                header: 'Tillägg',
                data: 'company_suffix',
                sortable: true,
            },
            {
                header: 'Medarbetare',
                data: 'user_name',
                sortable: true,
            },
            {
                header: 'Datum',
                data: 'start_ts',
                sortable: true,
            },
            // {
            //     header: 'Klar senast',
            //     data: 'end_ts',
            //     sortable: true,
            // },
        ],
        select_todo_dates: [
            { id: 'today', text: 'Aktuellt idag' },
            { id: 'today+1', text: 'Aktuellt imorgon' },
            { id: 'today+2', text: 'Aktuellt om 2 dagar' },
            { id: 'today+3', text: 'Aktuellt om 3 dagar' },
            { id: 'today+7', text: 'Aktuellt kommande vecka' },
            { id: 'today+30', text: 'Aktuellt kommande månad' },
            { id: 'all', text: 'Alla' },
        ],
        history_company: null,
        show_history_form_id: -1,
    }),
    mounted() {
        this.todo_filter.user_id = this.user.id;
    },
    methods: {
        rowClick(todo) {
            this.openTodoModal(todo.id);
        },
        async openTodoModal(todoId) {
            const vm = this;
            vm.history_company = null;
            vm.todo_busy = true;
            await apiClient.get(`/vue/sales/crm/todo/${todoId}`)
                .then((response) => {
                    vm.todo = response.data;
                    // eslint-disable-next-line no-undef
                    $('#modal_todo').modal('show');
                })
                .finally(() => {
                    vm.todo_busy = false;
                });
            if (vm.todo && vm.todo.company_id > 0) {
                await apiClient.get(`/vue/sales/crm/company/${vm.todo.company_id}`)
                    .then((response) => {
                        vm.history_company = response.data;
                    });
            }
        },
        async saveTodo() {
            const vm = this;
            const isValid = await vm.$refs.todoform.validate();
            if (isValid) {
                vm.todo_busy = true;
                await apiClient.post(`/vue/sales/crm/todo/${vm.todo.id}`, vm.todo)
                    .then((response) => {
                        vm.todo = response.data;
                        vm.$refs.btnsavetodo.triggerSaved();
                        vm.$refs.todotable.reload();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            vm.$refs.todoform.setErrors(parsederror);
                        }
                        vm.$refs.btnsavetodo.triggerFailed();
                    })
                    .finally(() => {
                        vm.todo_busy = false;
                    });
            } else {
                vm.$refs.btnsavetodo.triggerFailed();
            }
        },
        async deleteTodo() {
            const vm = this;
            // eslint-disable-next-line no-undef
            this.$swal({
                icon: 'warning',
                title: 'Vill du verkligen radera?',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera',
                cancelButtonText: 'Avbryt',
            }).then(async (result) => {
                if (result.value) {
                    vm.todo_busy = true;
                    await apiClient.delete(`/vue/sales/crm/todo/${vm.todo.id}`)
                        .then(() => {
                            vm.$refs.btndeletetodo.triggerSaved();
                            vm.$refs.todotable.reload();
                            // eslint-disable-next-line no-undef
                            $('#modal_todo').modal('hide');
                        })
                        .catch(() => {
                            vm.$refs.btndeletetodo.triggerFailed();
                        })
                        .finally(() => {
                            vm.todo_busy = false;
                        });
                }
            });
        },
        showHistoryForm(historyId = 0) {
            this.show_history_form_id = historyId;
        },
        historySaved(index, history) {
            if (index < 0) {
                this.history_company.history.unshift(history);
            } else {
                this.history_company.history[index] = history;
            }
            this.show_history_form_id = -1;
        },
    },
};
</script>

<style scoped>

</style>
